import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DayOfWeek } from '../hours-of-operation.interface';
import { HoursOfOperation } from '../hours-of-operation';

@Component({
  selector: 'forms-day-of-week-edit',
  templateUrl: './day-of-week-edit.component.html',
  styleUrls: ['./day-of-week-edit.component.scss'],
  standalone: false,
})
export class DayOfWeekEditComponent implements OnInit {
  private oldValue: HoursOfOperation;
  private _value: HoursOfOperation;

  @Input() dayOfWeek: DayOfWeek;
  @Input() get value(): HoursOfOperation {
    return this._value;
  }
  set value(val: HoursOfOperation) {
    this._value = val;
    this.valueChange.emit(this._value);
  }

  @Output() valueChange = new EventEmitter();

  @Output() hasAnyErrors = new EventEmitter();
  errorFieldsOfOneDay = new Array(7).fill(false);

  // make this constant available to the template
  DayOfWeek = DayOfWeek;

  private _closed: boolean;
  get closed(): boolean {
    return this._closed;
  }

  set closed(val: boolean) {
    this._closed = val;

    if (!this.closed) {
      if (this.oldValue) {
        this.value = this.oldValue;
      } else if (this.value.length === 0) {
        this.value.push({ opens: '9:00', closes: '17:00' });
      }
    } else {
      this.oldValue = this.value;
      this.value = [];
    }
  }

  ngOnInit(): void {
    if (!this._value) {
      this._value = [];
    }
    this._closed = this._value.length === 0;
  }

  delete(index: number): void {
    this.value.splice(index, 1);
  }

  addHours(): void {
    this.value.push({ opens: '9:00', closes: '17:00' });
  }

  dayDisplayNameKey(day: DayOfWeek): string {
    switch (day) {
      case DayOfWeek.PUBLIC_HOLIDAYS:
        return 'FRONTEND.FORMS.HOURS_OF_OPERATION.HOLIDAY_HOURS';
      case DayOfWeek.SUNDAY:
        return 'FRONTEND.FORMS.HOURS_OF_OPERATION.SUNDAY';
      case DayOfWeek.MONDAY:
        return 'FRONTEND.FORMS.HOURS_OF_OPERATION.MONDAY';
      case DayOfWeek.TUESDAY:
        return 'FRONTEND.FORMS.HOURS_OF_OPERATION.TUESDAY';
      case DayOfWeek.WEDNESDAY:
        return 'FRONTEND.FORMS.HOURS_OF_OPERATION.WEDNESDAY';
      case DayOfWeek.THURSDAY:
        return 'FRONTEND.FORMS.HOURS_OF_OPERATION.THURSDAY';
      case DayOfWeek.FRIDAY:
        return 'FRONTEND.FORMS.HOURS_OF_OPERATION.FRIDAY';
      case DayOfWeek.SATURDAY:
        return 'FRONTEND.FORMS.HOURS_OF_OPERATION.SATURDAY';
    }
    return day;
  }

  toggleChanged(): void {
    this.closed = !this.closed;

    // set to a default time when toggle is switched on, since validation won't trigger
    if (!this.closed) {
      this.value = [{ opens: '9:00', closes: '17:00' }];
    }

    // once close toggled, set every fields in this days to have no error
    this.errorFieldsOfOneDay = new Array(7).fill(false);
    // clear errors when the toggle is switched
    this.hasAnyErrors.emit(false);
  }

  handleHasAnyErrors(error: boolean, index: number): void {
    if (this.errorFieldsOfOneDay[index] !== error) {
      this.errorFieldsOfOneDay[index] = error;
      this.hasAnyErrors.emit(this.errorFieldsOfOneDay.indexOf(true) !== -1);
    }
  }
}
